"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../../../styles/myAccount/changePasswordModal.scss");
var _react = _interopRequireDefault(require("react"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _ReduxForm = _interopRequireDefault(require("angieslist-react-components/lib/ReduxForm"));
var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));
var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));
var _Modal = _interopRequireDefault(require("angieslist-react-components/lib/Modal"));
var _reduxForm = require("redux-form");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _changePassword = require("../../../validations/changePassword");
var _requiredTextLabel = require("../../requiredTextLabel");
var _getErrorMessage = _interopRequireDefault(require("angieslist-app-platform/lib/common/getErrorMessage"));
var changePasswordErrorMappings = {
  mappings: {
    '400': 'New password must not be the same as Old password',
    '403': 'Incorrect Old Password'
  }
};
var handleModalClose = function handleModalClose(handleClose, resetChangeUserPassword) {
  handleClose();
  resetChangeUserPassword();
};
var submit = function submit(changeUserPasswordApi, resetChangeUserPassword, handleClose, values) {
  changeUserPasswordApi(values.oldPassword, values.newPassword).then(function () {
    handleModalClose(handleClose, resetChangeUserPassword);
  });
};
var ChangePasswordModal = function ChangePasswordModal(_ref) {
  var changeUserPasswordApi = _ref.changeUserPasswordApi,
    editButtonStyle = _ref.editButtonStyle,
    handleSubmit = _ref.handleSubmit,
    changePassword = _ref.changePassword,
    pristine = _ref.pristine,
    invalid = _ref.invalid,
    resetChangeUserPassword = _ref.resetChangeUserPassword,
    handleClose = _ref.handleClose,
    showModal = _ref.showModal;
  var errorMessage = (0, _getErrorMessage["default"])(changePassword.error, changePasswordErrorMappings);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: function onHide() {
      return handleModalClose(handleClose, resetChangeUserPassword);
    },
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, "Change Password"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "reset-password",
    onSubmit: handleSubmit(function (values) {
      submit(changeUserPasswordApi, resetChangeUserPassword, handleClose, values);
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "oldPassword",
    id: "change-password-modal--old-password",
    type: "password",
    autoFocus: true,
    label: (0, _requiredTextLabel.markRequiredText)('Old Password:')
  }))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "newPassword",
    id: "change-password-modal--new-password",
    type: "password",
    label: (0, _requiredTextLabel.markRequiredText)('New Password:')
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-parent"
  }, /*#__PURE__*/_react["default"].createElement("li", null, "Must be at least 8 characters."), /*#__PURE__*/_react["default"].createElement("li", null, "No more than 2 consecutive repeated characters"), /*#__PURE__*/_react["default"].createElement("li", {
    className: "list-item-last"
  }, "('oo' works, but not 'ooo')")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "newPasswordConfirmation",
    id: "change-password-modal--confirm-new-password",
    type: "password",
    label: (0, _requiredTextLabel.markRequiredText)('New Password (Confirm):')
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "change-password-modal--change-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    type: "submit",
    disabled: pristine || invalid || changePassword.isLoading,
    loading: changePassword.isLoading
  }, "Change")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "change-password-modal--cancel-button",
    flat: true,
    bsStyle: "tertiary",
    bsSize: "small",
    onClick: function onClick() {
      return handleModalClose(handleClose, resetChangeUserPassword);
    }
  }, "Cancel")))));
};

// Prop Types
ChangePasswordModal.propTypes = {
  changeUserPasswordApi: _propTypes["default"].func,
  editButtonStyle: _propTypes["default"].string,
  changePassword: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    error: _propTypes["default"].object
  }),
  resetChangeUserPassword: _propTypes["default"].func.isRequired,
  // Redux-form props
  handleSubmit: _propTypes["default"].func.isRequired,
  dirty: _propTypes["default"].bool.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _reduxForm.reduxForm)({
  form: 'reset-password',
  validate: function validate(values, _ref2) {
    var dirty = _ref2.dirty;
    return dirty ? _angieslistAppPlatform.validation.validate(values, _changePassword.changePasswordValidationRules).invalidAttrs : {};
  }
}), _pure["default"])(ChangePasswordModal);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/modals/changePasswordModal.js
// module id = 4060
// module chunks = 9